/**
 *
 * DeleteButton
 *
 */

import React, { memo, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { Button, Popconfirm, notification } from "antd";

// utils
import history from "utils/history";

function DeleteButton({
  buttonText,
  message,
  successMessage,
  loading,
  pathname,
  deleteHandle,
  // default props
  className,
}) {
  const childClassNames = classNames("delete-button-wrapper", className);
  const { t } = useTranslation();

  useEffect(() => {
    if (loading) {
      const defaultSuccessMessage = typeof successMessage === "string" ? t(successMessage) : successMessage;
      history.push({ pathname });
      notification.success({ message: defaultSuccessMessage });
    }
  }, [loading]);

  const defaultMessage = typeof message === "string" ? t(message) : message;
  const defaultButtonText = typeof buttonText === "string" ? t(buttonText) : buttonText;

  return (
    <>
      <Popconfirm
        placement="top"
        title={defaultMessage}
        onConfirm={() => deleteHandle()}
        okText={t("common.delete")}
        cancelText={t("common.cancel")}
        overlayClassName="popconfirm-window"
      >
        <Button loading={loading} className={childClassNames}>
          {defaultButtonText}
        </Button>
      </Popconfirm>
    </>
  );
}

DeleteButton.defaultProps = {
  pathname: "/сours/",
  message: "components.deleteButton.message",
  successMessage: "components.deleteButton.successMessage",
  buttonText: "components.deleteButton.buttonText",
};
DeleteButton.propTypes = {
  loading: PropTypes.bool,
  deleteHandle: PropTypes.func,
};

export default memo(DeleteButton);
